import styled from 'styled-components';

export default styled.label`
    font-size: 1rem;
    color: #595959;
    font-weight: ${({ important }) => (important ? 'bold' : 'normal')};
    display: ${({ inline }) => (inline ? 'inline-block' : 'block')};
    margin-top: 0;
    margin-left: 0;
    ${({ inline }) =>
        inline
            ? `
        margin-right: 1em;
        margin-bottom: 0;
    `
            : `
        margin-right: 0;
        margin-bottom: 0.2em;
    `} ${({ optional }) =>
        optional
            ? `
            ::after {
                content: "(Optional)";
                padding-left: .2em;
                color: #999999;
            }
        `
            : ''};
`;
